import { LocationWorkStatus } from 'global-graphql-types'
import ActiveShift from 'components/ActiveShift'
import PageError from 'components/pages/PageError'

import { ShiftPageQuery } from './types/ShiftPageQuery'

type LocationType = NonNullable<ShiftPageQuery['location']>

const ShiftMenu = ({
  location,
  hideLocationInformation
}: {
  location: LocationType
  hideLocationInformation: boolean
}) => {
  if (location.workStatus === LocationWorkStatus.WorkEnded) {
    return (
      <div className="h-80">
        <PageError>The shift has ended</PageError>
      </div>
    )
  }

  return (
    <ActiveShift
      hideLocationInformation={hideLocationInformation}
      hideOrdersProgress={false}
      itemSource="web_shift_new"
      locationId={location.id}
    />
  )
}

export default ShiftMenu
